export const SESSION_STATUSES = [
    "CHARGING",
    "FINISHING",
    "SUSPENDEDEV",
    "SUSPENDEDEVSE",
    "EVCONNECTED",
    "IDLE",
];

const START_ON_AVAILABLE_SITE_NAMES = ["Strängnäs Kvartsgatan", "Sala Evelunds rastplats"];

function normalizeWords(value) {
    return (value || "")
        .toLowerCase()
        .replace(/[|/\\\-–:_]+/g, " ")
        .split(/\s+/)
        .filter(Boolean);
}

export function stripSiteWords(siteName, value) {
    if (!value) {
        return "–";
    }

    const siteWords = new Set(normalizeWords(siteName ?? ""));
    if (siteWords.size === 0) {
        return value;
    }

    const result = value
        .split(/\s+/)
        .filter((word) => !siteWords.has(word.toLowerCase()))
        .join(" ")
        .trim();

    return result || value;
}

export function canStartCharging(status, siteName) {
    if (status === "PREPARING" || status === "OCCUPIED" || status === "EVCONNECTED") {
        return true;
    }
    if (status === "RESERVED") {
        return false;
    }
    if (status !== "AVAILABLE") {
        return false;
    }

    const lowerSiteName = (siteName || "").toLowerCase();
    return START_ON_AVAILABLE_SITE_NAMES.some((name) => lowerSiteName.includes(name.toLowerCase()));
}

export function getConnectorPublicIdFromItem(item) {
    const data = item?.Data || {};
    return data.chargingConnectorPublicId || data.ChargingConnectorPublicId;
}
